 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COMMON00_COVER from '@/components/Common/00_Cover'
 import EBB from '@/components/ebb'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import COMMON01_TITLE from '@/components/Common/01_Title'
 import COVERIMAGE from '@/components/CoverImage'
 import PASTIMPERATIVE from '@/components/PastImperative'
 import PASTIMPERATIVE2 from '@/components/PastImperative2'
 import PASTIMPERATIVE3 from '@/components/PastImperative3'
 import PASTIMPERATIVE4 from '@/components/PastImperative4'
 import PASTIMPERATIVE5 from '@/components/PastImperative5'
 import PASTIMPERATIVE6 from '@/components/PastImperative6'
 import PASTIMPERATIVE7 from '@/components/PastImperative7'
 import PASTIMPERATIVE8 from '@/components/PastImperative8'
 import PASTIMPERATIVE9 from '@/components/PastImperative9'
 import PASTIMPERATIVE10 from '@/components/PastImperative10'
 import PASTIMPERATIVE11 from '@/components/PastImperative11'
 import PASTIMPERATIVE12 from '@/components/PastImperative12'
 import PASTIMPERATIVE13 from '@/components/PastImperative13'
 import PASTIMPERATIVE14 from '@/components/PastImperative14'
 import PASTIMPERATIVE15 from '@/components/PastImperative15'
 import PASTIMPERATIVE16 from '@/components/PastImperative16'
 import PASTIMPERATIVE17 from '@/components/PastImperative17'
 import PASTIMPERATIVE18 from '@/components/PastImperative18'
 import PASTIMPERATIVE19 from '@/components/PastImperative19'
 import PASTIMPERATIVE20 from '@/components/PastImperative20'
 import PASTIMPERATIVE21 from '@/components/PastImperative21'
 import PASTIMPERATIVE22 from '@/components/PastImperative22'
 import PASTIMPERATIVE23 from '@/components/PastImperative23'
 import PASTIMPERATIVE24 from '@/components/PastImperative24'
 import PASTIMPERATIVE25 from '@/components/PastImperative25'
 import PASTIMPERATIVE26 from '@/components/PastImperative26'
 import PASTIMPERATIVE27 from '@/components/PastImperative27'
 import PASTIMPERATIVE28 from '@/components/PastImperative28'
 import PASTIMPERATIVE29 from '@/components/PastImperative29'
 import PASTIMPERATIVE30 from '@/components/PastImperative30'
 import PASTIMPERATIVE31 from '@/components/PastImperative31'
 import PASTIMPERATIVE32 from '@/components/PastImperative32'
 import PASTIMPERATIVE33 from '@/components/PastImperative33'
 import PASTIMPERATIVE34 from '@/components/PastImperative34'
 import PASTIMPERATIVE35 from '@/components/PastImperative35'
 import PASTIMPERATIVE36 from '@/components/PastImperative36'
 import PASTIMPERATIVE37 from '@/components/PastImperative37'
 import PASTIMPERATIVE38 from '@/components/PastImperative38'
 import PASTIMPERATIVE39 from '@/components/PastImperative39'
 import PASTIMPERATIVE40 from '@/components/PastImperative40'
 import PASTIMPERATIVE41 from '@/components/PastImperative41'
 import PASTIMPERATIVE42 from '@/components/PastImperative42'
 import PASTIMPERATIVE43 from '@/components/PastImperative43'
 import PASTIMPERATIVE44 from '@/components/PastImperative44'
 import PASTIMPERATIVE45 from '@/components/PastImperative45'
 import PASTIMPERATIVE46 from '@/components/PastImperative46'
 import PASTIMPERATIVE47 from '@/components/PastImperative47'
 import PASTIMPERATIVE48 from '@/components/PastImperative48'
 import PASTIMPERATIVE49 from '@/components/PastImperative49'
 import PASTIMPERATIVE50 from '@/components/PastImperative50'
 import PASTIMPERATIVE51 from '@/components/PastImperative51'
 import PASTIMPERATIVE52 from '@/components/PastImperative52'
 import PASTIMPERATIVE53 from '@/components/PastImperative53'
 import PASTIMPERATIVE54 from '@/components/PastImperative54'
 import PASTIMPERATIVE55 from '@/components/PastImperative55'
 import PASTIMPERATIVE56 from '@/components/PastImperative56'
 import PASTIMPERATIVE57 from '@/components/PastImperative57'
 import PASTIMPERATIVE58 from '@/components/PastImperative58'
 import PASTIMPERATIVE59 from '@/components/PastImperative59'
 import PASTIMPERATIVE60 from '@/components/PastImperative60'
 import PASTIMPERATIVE61 from '@/components/PastImperative61'
 import PASTIMPERATIVE62 from '@/components/PastImperative62'
 import PASTIMPERATIVE63 from '@/components/PastImperative63'
 import PASTIMPERATIVE64 from '@/components/PastImperative64'
 import PASTIMPERATIVE65 from '@/components/PastImperative65'
 import PASTIMPERATIVE66 from '@/components/PastImperative66'
 import PASTIMPERATIVE67 from '@/components/PastImperative67'
 import PASTIMPERATIVE68 from '@/components/PastImperative68'
 import PASTIMPERATIVE69 from '@/components/PastImperative69'
 import PASTIMPERATIVE70 from '@/components/PastImperative70'
 import PASTIMPERATIVE71 from '@/components/PastImperative71'
 import PASTIMPERATIVE72 from '@/components/PastImperative72'
 import PASTIMPERATIVE73 from '@/components/PastImperative73'
 import PASTIMPERATIVE74 from '@/components/PastImperative74'
 import PASTIMPERATIVE75 from '@/components/PastImperative75'
 import BOOK2COVERIMAGE from '@/components/Book2/CoverImage'
 import BOOK2PRESENTTENSE from '@/components/Book2/PresentTense'
 import BOOK2PRESENTTENSE2 from '@/components/Book2/PresentTense2'
 import BOOK2PRESENTTENSE3 from '@/components/Book2/PresentTense3'
 import BOOK2PRESENTTENSE4 from '@/components/Book2/PresentTense4'
 import BOOK2PRESENTTENSE5 from '@/components/Book2/PresentTense5'
 import BOOK2PRESENTTENSE6 from '@/components/Book2/PresentTense6'
 import BOOK2PRESENTTENSE7 from '@/components/Book2/PresentTense7'
 import BOOK2PRESENTTENSE8 from '@/components/Book2/PresentTense8'
 import BOOK2PRESENTTENSE9 from '@/components/Book2/PresentTense9'
 import BOOK2PRESENTTENSE10 from '@/components/Book2/PresentTense10'
 import BOOK2PRESENTTENSE11 from '@/components/Book2/PresentTense11'
 import BOOK2PRESENTTENSE12 from '@/components/Book2/PresentTense12'
 import BOOK2PRESENTTENSE13 from '@/components/Book2/PresentTense13'
 import BOOK2PRESENTTENSE14 from '@/components/Book2/PresentTense14'
 import BOOK2PRESENTTENSE15 from '@/components/Book2/PresentTense15'
 import BOOK2PRESENTTENSE16 from '@/components/Book2/PresentTense16'
 import BOOK2PRESENTTENSE17 from '@/components/Book2/PresentTense17'
 import BOOK2PRESENTTENSE18 from '@/components/Book2/PresentTense18'
 import BOOK2PRESENTTENSE19 from '@/components/Book2/PresentTense19'
 import BOOK2PRESENTTENSE20 from '@/components/Book2/PresentTense20'
 import BOOK2PRESENTTENSE21 from '@/components/Book2/PresentTense21'
 import BOOK2PRESENTTENSE22 from '@/components/Book2/PresentTense22'
 import BOOK2PRESENTTENSE23 from '@/components/Book2/PresentTense23'
 import BOOK2PRESENTTENSE24 from '@/components/Book2/PresentTense24'
 import BOOK2PRESENTTENSE25 from '@/components/Book2/PresentTense25'
 import BOOK2PRESENTTENSE26 from '@/components/Book2/PresentTense26'
 import BOOK2PRESENTTENSE27 from '@/components/Book2/PresentTense27'
 import BOOK2PRESENTTENSE28 from '@/components/Book2/PresentTense28'
 import BOOK2PRESENTTENSE29 from '@/components/Book2/PresentTense29'
 import BOOK2PRESENTTENSE30 from '@/components/Book2/PresentTense30'
 import BOOK2PRESENTTENSE31 from '@/components/Book2/PresentTense31'
 import BOOK2PRESENTTENSE32 from '@/components/Book2/PresentTense32'
 import BOOK2PRESENTTENSE33 from '@/components/Book2/PresentTense33'
 import BOOK2PRESENTTENSE34 from '@/components/Book2/PresentTense34'
 import BOOK2PRESENTTENSE35 from '@/components/Book2/PresentTense35'
 import BOOK2PRESENTTENSE36 from '@/components/Book2/PresentTense36'
 import BOOK2PRESENTTENSE37 from '@/components/Book2/PresentTense37'
 import BOOK2PRESENTTENSE38 from '@/components/Book2/PresentTense38'
 import BOOK2PRESENTTENSE39 from '@/components/Book2/PresentTense39'
 import BOOK2PRESENTTENSE40 from '@/components/Book2/PresentTense40'
 import BOOK2PRESENTTENSE41 from '@/components/Book2/PresentTense41'
 import BOOK2PRESENTTENSE42 from '@/components/Book2/PresentTense42'
 import BOOK2PRESENTTENSE43 from '@/components/Book2/PresentTense43'
 import BOOK2PRESENTTENSE44 from '@/components/Book2/PresentTense44'
 import BOOK2PRESENTTENSE45 from '@/components/Book2/PresentTense45'
 import BOOK2PRESENTTENSE46 from '@/components/Book2/PresentTense46'
 import BOOK2PRESENTTENSE47 from '@/components/Book2/PresentTense47'
 import BOOK2PRESENTTENSE48 from '@/components/Book2/PresentTense48'
 import BOOK2PRESENTTENSE49 from '@/components/Book2/PresentTense49'
 import BOOK2PRESENTTENSE50 from '@/components/Book2/PresentTense50'
 import BOOK2PRESENTTENSE51 from '@/components/Book2/PresentTense51'
 import BOOK2PRESENTTENSE52 from '@/components/Book2/PresentTense52'
 import BOOK2PRESENTTENSE53 from '@/components/Book2/PresentTense53'
 import BOOK2PRESENTTENSE54 from '@/components/Book2/PresentTense54'
 import BOOK2PRESENTTENSE55 from '@/components/Book2/PresentTense55'
 import BOOK2PRESENTTENSE56 from '@/components/Book2/PresentTense56'
 import BOOK2PRESENTTENSE57 from '@/components/Book2/PresentTense57'
 import BOOK2PRESENTTENSE58 from '@/components/Book2/PresentTense58'
 import BOOK2PRESENTTENSE59 from '@/components/Book2/PresentTense59'
 import BOOK2PRESENTTENSE60 from '@/components/Book2/PresentTense60'
 import BOOK2PRESENTTENSE61 from '@/components/Book2/PresentTense61'
 import BOOK2PRESENTTENSE62 from '@/components/Book2/PresentTense62'
 import BOOK2PRESENTTENSE63 from '@/components/Book2/PresentTense63'
 import BOOK2PRESENTTENSE64 from '@/components/Book2/PresentTense64'
 import BOOK2PRESENTTENSE65 from '@/components/Book2/PresentTense65'
 import BOOK2PRESENTTENSE66 from '@/components/Book2/PresentTense66'
 import BOOK3FUTUREINDEFINITE_COV from '@/components/Book3/futureindefinite_cov'
 import BOOK3FUTUREINDEFINITE_TIT01 from '@/components/Book3/futureindefinite_tit01'
 import BOOK3FUTUREINDEFINITE_DED01 from '@/components/Book3/futureindefinite_ded01'
 import BOOK3FUTUREINDEFINITE_F01 from '@/components/Book3/futureindefinite_f01'
 import BOOK3FUTUREINDEFINITE_F01A from '@/components/Book3/futureindefinite_f01a'
 import BOOK3FUTUREINDEFINITE_EPI01 from '@/components/Book3/futureindefinite_epi01'
 import BOOK3FUTUREINDEFINITE_FM01 from '@/components/Book3/futureindefinite_fm01'
 import BOOK3FUTUREINDEFINITE_FM01A from '@/components/Book3/futureindefinite_fm01a'
 import BOOK3FUTUREINDEFINITE_PT01 from '@/components/Book3/futureindefinite_pt01'
 import BOOK3FUTUREINDEFINITE_CH01 from '@/components/Book3/futureindefinite_ch01'
 import BOOK3FUTUREINDEFINITE_PT02 from '@/components/Book3/futureindefinite_pt02'
 import BOOK3FUTUREINDEFINITE_CH02 from '@/components/Book3/futureindefinite_ch02'
 import BOOK3FUTUREINDEFINITE_CH03 from '@/components/Book3/futureindefinite_ch03'
 import BOOK3FUTUREINDEFINITE_CH04 from '@/components/Book3/futureindefinite_ch04'
 import BOOK3FUTUREINDEFINITE_CH05 from '@/components/Book3/futureindefinite_ch05'
 import BOOK3FUTUREINDEFINITE_CH06 from '@/components/Book3/futureindefinite_ch06'
 import BOOK3FUTUREINDEFINITE_PT03 from '@/components/Book3/futureindefinite_pt03'
 import BOOK3FUTUREINDEFINITE_CH07 from '@/components/Book3/futureindefinite_ch07'
 import BOOK3FUTUREINDEFINITE_CH08 from '@/components/Book3/futureindefinite_ch08'
 import BOOK3FUTUREINDEFINITE_CH09 from '@/components/Book3/futureindefinite_ch09'
 import BOOK3FUTUREINDEFINITE_CH10 from '@/components/Book3/futureindefinite_ch10'
 import BOOK3FUTUREINDEFINITE_CH11 from '@/components/Book3/futureindefinite_ch11'
 import BOOK3FUTUREINDEFINITE_CH12 from '@/components/Book3/futureindefinite_ch12'
 import BOOK3FUTUREINDEFINITE_CH13 from '@/components/Book3/futureindefinite_ch13'
 import BOOK3FUTUREINDEFINITE_CH14 from '@/components/Book3/futureindefinite_ch14'
 import BOOK3FUTUREINDEFINITE_CH15 from '@/components/Book3/futureindefinite_ch15'
 import BOOK3FUTUREINDEFINITE_CH16 from '@/components/Book3/futureindefinite_ch16'
 import BOOK3FUTUREINDEFINITE_PT04 from '@/components/Book3/futureindefinite_pt04'
 import BOOK3FUTUREINDEFINITE_CH17 from '@/components/Book3/futureindefinite_ch17'
 import BOOK3FUTUREINDEFINITE_CH18 from '@/components/Book3/futureindefinite_ch18'
 import BOOK3FUTUREINDEFINITE_CH19 from '@/components/Book3/futureindefinite_ch19'
 import BOOK3FUTUREINDEFINITE_CH20 from '@/components/Book3/futureindefinite_ch20'
 import BOOK3FUTUREINDEFINITE_PT05 from '@/components/Book3/futureindefinite_pt05'
 import BOOK3FUTUREINDEFINITE_CH21 from '@/components/Book3/futureindefinite_ch21'
 import BOOK3FUTUREINDEFINITE_CH22 from '@/components/Book3/futureindefinite_ch22'
 import BOOK3FUTUREINDEFINITE_CH23 from '@/components/Book3/futureindefinite_ch23'
 import BOOK3FUTUREINDEFINITE_CH24 from '@/components/Book3/futureindefinite_ch24'
 import BOOK3FUTUREINDEFINITE_CH25 from '@/components/Book3/futureindefinite_ch25'
 import BOOK3FUTUREINDEFINITE_CH26 from '@/components/Book3/futureindefinite_ch26'
 import BOOK3FUTUREINDEFINITE_CH27 from '@/components/Book3/futureindefinite_ch27'
 import BOOK3FUTUREINDEFINITE_CH28 from '@/components/Book3/futureindefinite_ch28'
 import BOOK3FUTUREINDEFINITE_CH29 from '@/components/Book3/futureindefinite_ch29'
 import BOOK3FUTUREINDEFINITE_CH30 from '@/components/Book3/futureindefinite_ch30'
 import BOOK3FUTUREINDEFINITE_CH31 from '@/components/Book3/futureindefinite_ch31'
 import BOOK3FUTUREINDEFINITE_CH32 from '@/components/Book3/futureindefinite_ch32'
 import BOOK3FUTUREINDEFINITE_CH33 from '@/components/Book3/futureindefinite_ch33'
 import BOOK3FUTUREINDEFINITE_PT06 from '@/components/Book3/futureindefinite_pt06'
 import BOOK3FUTUREINDEFINITE_CH34 from '@/components/Book3/futureindefinite_ch34'
 import BOOK3FUTUREINDEFINITE_CH35 from '@/components/Book3/futureindefinite_ch35'
 import BOOK3FUTUREINDEFINITE_CH36 from '@/components/Book3/futureindefinite_ch36'
 import BOOK3FUTUREINDEFINITE_CH37 from '@/components/Book3/futureindefinite_ch37'
 import BOOK3FUTUREINDEFINITE_CH38 from '@/components/Book3/futureindefinite_ch38'
 import BOOK3FUTUREINDEFINITE_CH39 from '@/components/Book3/futureindefinite_ch39'
 import BOOK3FUTUREINDEFINITE_CH40 from '@/components/Book3/futureindefinite_ch40'
 import BOOK3FUTUREINDEFINITE_CH41 from '@/components/Book3/futureindefinite_ch41'
 import BOOK3FUTUREINDEFINITE_CH42 from '@/components/Book3/futureindefinite_ch42'
 import BOOK3FUTUREINDEFINITE_CH43 from '@/components/Book3/futureindefinite_ch43'
 import BOOK3FUTUREINDEFINITE_CH44 from '@/components/Book3/futureindefinite_ch44'
 import BOOK3FUTUREINDEFINITE_CH45 from '@/components/Book3/futureindefinite_ch45'
 import BOOK3FUTUREINDEFINITE_CH46 from '@/components/Book3/futureindefinite_ch46'
 import BOOK3FUTUREINDEFINITE_CH47 from '@/components/Book3/futureindefinite_ch47'
 import BOOK3FUTUREINDEFINITE_PT07 from '@/components/Book3/futureindefinite_pt07'
 import BOOK3FUTUREINDEFINITE_CH48 from '@/components/Book3/futureindefinite_ch48'
 import BOOK3FUTUREINDEFINITE_CH49 from '@/components/Book3/futureindefinite_ch49'
 import BOOK3FUTUREINDEFINITE_CH50 from '@/components/Book3/futureindefinite_ch50'
 import BOOK3FUTUREINDEFINITE_PT08 from '@/components/Book3/futureindefinite_pt08'
 import BOOK3FUTUREINDEFINITE_CH51 from '@/components/Book3/futureindefinite_ch51'
 import BOOK3FUTUREINDEFINITE_CH52 from '@/components/Book3/futureindefinite_ch52'
 import BOOK3FUTUREINDEFINITE_CH53 from '@/components/Book3/futureindefinite_ch53'
 import BOOK3FUTUREINDEFINITE_CH54 from '@/components/Book3/futureindefinite_ch54'
 import BOOK3FUTUREINDEFINITE_CH55 from '@/components/Book3/futureindefinite_ch55'
 import BOOK3FUTUREINDEFINITE_CH56 from '@/components/Book3/futureindefinite_ch56'
 import BOOK3FUTUREINDEFINITE_CH57 from '@/components/Book3/futureindefinite_ch57'
 import BOOK3FUTUREINDEFINITE_CH58 from '@/components/Book3/futureindefinite_ch58'
 import BOOK3FUTUREINDEFINITE_CH59 from '@/components/Book3/futureindefinite_ch59'
 import BOOK3FUTUREINDEFINITE_CH60 from '@/components/Book3/futureindefinite_ch60'
 import BOOK3FUTUREINDEFINITE_PT11 from '@/components/Book3/futureindefinite_pt11'
 import BOOK3FUTUREINDEFINITE_CH61 from '@/components/Book3/futureindefinite_ch61'
 import BOOK3FUTUREINDEFINITE_CH62 from '@/components/Book3/futureindefinite_ch62'
 import BOOK3FUTUREINDEFINITE_CH63 from '@/components/Book3/futureindefinite_ch63'
 import LOVE_2 from '@/components/love_2'
 import BOOK3FUTUREINDEFINITE_BM01 from '@/components/Book3/futureindefinite_bm01'
 import BOOK3FOOTNOTE1 from '@/components/Book3/footnote1'
 import SECTION74 from '@/components/section74'
 import COMMONCOPYRIGHT from '@/components/Common/copyright'
 import COMMONORIMAD from '@/components/Common/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Common/00_Cover",
 			"name" : "Common/00_Cover",
 			"component" : COMMON00_COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Common/01_Title",
 			"name" : "Common/01_Title",
 			"component" : COMMON01_TITLE
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/PastImperative",
 			"name" : "PastImperative",
 			"component" : PASTIMPERATIVE
 		},
 		{
 			"path" : "/PastImperative2",
 			"name" : "PastImperative2",
 			"component" : PASTIMPERATIVE2
 		},
 		{
 			"path" : "/PastImperative3",
 			"name" : "PastImperative3",
 			"component" : PASTIMPERATIVE3
 		},
 		{
 			"path" : "/PastImperative4",
 			"name" : "PastImperative4",
 			"component" : PASTIMPERATIVE4
 		},
 		{
 			"path" : "/PastImperative5",
 			"name" : "PastImperative5",
 			"component" : PASTIMPERATIVE5
 		},
 		{
 			"path" : "/PastImperative6",
 			"name" : "PastImperative6",
 			"component" : PASTIMPERATIVE6
 		},
 		{
 			"path" : "/PastImperative7",
 			"name" : "PastImperative7",
 			"component" : PASTIMPERATIVE7
 		},
 		{
 			"path" : "/PastImperative8",
 			"name" : "PastImperative8",
 			"component" : PASTIMPERATIVE8
 		},
 		{
 			"path" : "/PastImperative9",
 			"name" : "PastImperative9",
 			"component" : PASTIMPERATIVE9
 		},
 		{
 			"path" : "/PastImperative10",
 			"name" : "PastImperative10",
 			"component" : PASTIMPERATIVE10
 		},
 		{
 			"path" : "/PastImperative11",
 			"name" : "PastImperative11",
 			"component" : PASTIMPERATIVE11
 		},
 		{
 			"path" : "/PastImperative12",
 			"name" : "PastImperative12",
 			"component" : PASTIMPERATIVE12
 		},
 		{
 			"path" : "/PastImperative13",
 			"name" : "PastImperative13",
 			"component" : PASTIMPERATIVE13
 		},
 		{
 			"path" : "/PastImperative14",
 			"name" : "PastImperative14",
 			"component" : PASTIMPERATIVE14
 		},
 		{
 			"path" : "/PastImperative15",
 			"name" : "PastImperative15",
 			"component" : PASTIMPERATIVE15
 		},
 		{
 			"path" : "/PastImperative16",
 			"name" : "PastImperative16",
 			"component" : PASTIMPERATIVE16
 		},
 		{
 			"path" : "/PastImperative17",
 			"name" : "PastImperative17",
 			"component" : PASTIMPERATIVE17
 		},
 		{
 			"path" : "/PastImperative18",
 			"name" : "PastImperative18",
 			"component" : PASTIMPERATIVE18
 		},
 		{
 			"path" : "/PastImperative19",
 			"name" : "PastImperative19",
 			"component" : PASTIMPERATIVE19
 		},
 		{
 			"path" : "/PastImperative20",
 			"name" : "PastImperative20",
 			"component" : PASTIMPERATIVE20
 		},
 		{
 			"path" : "/PastImperative21",
 			"name" : "PastImperative21",
 			"component" : PASTIMPERATIVE21
 		},
 		{
 			"path" : "/PastImperative22",
 			"name" : "PastImperative22",
 			"component" : PASTIMPERATIVE22
 		},
 		{
 			"path" : "/PastImperative23",
 			"name" : "PastImperative23",
 			"component" : PASTIMPERATIVE23
 		},
 		{
 			"path" : "/PastImperative24",
 			"name" : "PastImperative24",
 			"component" : PASTIMPERATIVE24
 		},
 		{
 			"path" : "/PastImperative25",
 			"name" : "PastImperative25",
 			"component" : PASTIMPERATIVE25
 		},
 		{
 			"path" : "/PastImperative26",
 			"name" : "PastImperative26",
 			"component" : PASTIMPERATIVE26
 		},
 		{
 			"path" : "/PastImperative27",
 			"name" : "PastImperative27",
 			"component" : PASTIMPERATIVE27
 		},
 		{
 			"path" : "/PastImperative28",
 			"name" : "PastImperative28",
 			"component" : PASTIMPERATIVE28
 		},
 		{
 			"path" : "/PastImperative29",
 			"name" : "PastImperative29",
 			"component" : PASTIMPERATIVE29
 		},
 		{
 			"path" : "/PastImperative30",
 			"name" : "PastImperative30",
 			"component" : PASTIMPERATIVE30
 		},
 		{
 			"path" : "/PastImperative31",
 			"name" : "PastImperative31",
 			"component" : PASTIMPERATIVE31
 		},
 		{
 			"path" : "/PastImperative32",
 			"name" : "PastImperative32",
 			"component" : PASTIMPERATIVE32
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js